import { useCallback } from 'react'
import {
  LANGUAGE_HEADER_HEIGHT_FALLBACK,
  NAV_BAR_HEIGHT_DESKTOP,
  NAV_BAR_HEIGHT_MOBILE,
  JOIN_BANNER_HEIGHT_MOBILE,
} from 'components/main-nav-bar/constants'
import { UseHeaderHeightProps } from 'components/main-nav-bar/types'

export const useHeaderHeight = ({
  isMounted,
  isMobileView,
  shouldRenderLanguageHeader,
  isLanguageHeaderVisible,
  shouldRenderJoinBanner,
  isHeaderGroupVisible,
  mainNavRef,
  languageHeaderRef,
  joinBannerRef,
}: UseHeaderHeightProps) => {
  const updateHeaderTotalHeightVariable = useCallback(() => {
    if (!isMounted || typeof document === 'undefined') return

    let totalHeight = 0

    if (shouldRenderLanguageHeader && isLanguageHeaderVisible) {
      let currentLangHeaderHeight = 0
      if (languageHeaderRef.current) {
        try {
          currentLangHeaderHeight = languageHeaderRef.current.getBoundingClientRect().height
        } catch (error) {
          currentLangHeaderHeight = LANGUAGE_HEADER_HEIGHT_FALLBACK
        }
      } else {
        currentLangHeaderHeight = LANGUAGE_HEADER_HEIGHT_FALLBACK
      }

      totalHeight +=
        currentLangHeaderHeight > 0 ? currentLangHeaderHeight : LANGUAGE_HEADER_HEIGHT_FALLBACK
    }

    const navbarHeight = mainNavRef.current
      ? mainNavRef.current.getBoundingClientRect().height
      : isMobileView
      ? NAV_BAR_HEIGHT_MOBILE
      : NAV_BAR_HEIGHT_DESKTOP
    totalHeight += navbarHeight

    if (shouldRenderJoinBanner) {
      const bannerHeight = joinBannerRef.current
        ? joinBannerRef.current.getBoundingClientRect().height
        : JOIN_BANNER_HEIGHT_MOBILE
      totalHeight += bannerHeight > 0 ? bannerHeight : JOIN_BANNER_HEIGHT_MOBILE
    }

    document.documentElement.style.setProperty('--header-total-height', `${totalHeight}px`)
  }, [
    isMounted,
    shouldRenderLanguageHeader,
    isLanguageHeaderVisible,
    isMobileView,
    shouldRenderJoinBanner,
    mainNavRef,
    languageHeaderRef,
    joinBannerRef,
  ])

  return { updateHeaderTotalHeightVariable }
}
